import React, { Component } from "react";
import { Helmet } from "react-helmet";
import "./Style.scss";
import { Container, Col, Row } from "react-bootstrap";
import InvestorGrievanceTable from "../../Defaults/Footer/InvestorGrievance/InvestorGrievanceTable";
import ComplianceOffice from "../../Defaults/Footer/FooterContents/ComplianceOffice";

export class Contact extends Component {
  render() {
    return (
      <>
        <Helmet>
          <title>Contact Us ~ OPG Securities</title>
        </Helmet>
        <div className="wrapper contactContainer">
          <div className="contactHeader container headerforall">
            <div className="leftHeader">
              <h1>CONTACT US</h1>
            </div>
            <div className="rightHeader">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/" className="inActive">
                      Home
                    </a>
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">
                    Contact Us
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <Container className="contact paragraphforall">
            <Row>
              <Col md={6}>
                <div className="locationContainer">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14670.501085303342!2d72.652368!3d23.183873!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2a67b5b6f42d%3A0x2656f7917e25f877!2sShree%20Rang%20Mall%20%26%20Nagar!5e0!3m2!1sen!2sin!4v1698906278477!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="Registered Office"
                  ></iframe>
                  <h4 className="title">REGISTERED OFFICE</h4>
                  <div className="locationNames">
                    <div className="locationName">
                      <i className="fas fa-location-arrow"></i>
                    </div>
                    <div className="locationDisc">
                      <h6>OPG SECURITIES</h6>
                      <p className="disc">
                        Shop No. 238,Shree Rang Mall, Gift City Road, Randesan,
                        GIFT City Gandhinagar, Gujarat-38242
                      </p>
                    </div>
                  </div>
                  <a
                    href="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14670.501085303342!2d72.652368!3d23.183873!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395c2a67b5b6f42d%3A0x2656f7917e25f877!2sShree%20Rang%20Mall%20%26%20Nagar!5e0!3m2!1sen!2sin!4v1698906278477!5m2!1sen!2sin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    Get Location <i className="fas fa-location-arrow"></i>
                  </a>
                </div>
              </Col>
              <Col md={6}>
                <div className="locationContainer">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14006.608966387756!2d77.298068!3d28.640183!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb51c2a42b51%3A0xba623124b276d58b!2s24%2C%20Block%20E%2C%20Preet%20Vihar%2C%20Delhi%2C%20110092!5e0!3m2!1sen!2sin!4v1698906318026!5m2!1sen!2sin"
                    width="600"
                    height="450"
                    style={{ border: "0" }}
                    allowfullscreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                    title="Corporate Office"
                  ></iframe>
                  <h4 className="title">CORPORATE OFFICE</h4>
                  <div className="locationNames">
                    <div className="locationDisc">
                      <h6>OPG SECURITIES</h6>
                      <p className="disc">
                        <i className="fas fa-location-arrow"></i> E-24, Preet
                        Vihar, Delhi – 110092.
                      </p>
                      <p className="disc">
                        <i className="fas fa-phone"></i>{" "}
                        <a href="tel: 011-42770073">011-42770073</a>
                        <br />
                        <i className="fas fa-mail-bulk"></i>{" "}
                        <a href="mailto: opgdelhi@opgsecurities.com">
                          opgdelhi@opgsecurities.com
                        </a>
                      </p>
                    </div>
                  </div>
                  <a
                    href="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14006.608966387756!2d77.298068!3d28.640183!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfb51c2a42b51%3A0xba623124b276d58b!2s24%2C%20Block%20E%2C%20Preet%20Vihar%2C%20Delhi%2C%20110092!5e0!3m2!1sen!2sin!4v1698906318026!5m2!1sen!2sin"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn"
                  >
                    Get Location <i className="fas fa-location-arrow"></i>
                  </a>
                </div>
              </Col>
            </Row>
            <h2 className="contactOuterTitle">Compliance Officer Details</h2>
            <ComplianceOffice />
            <h2 className="contactOuterTitle">Escalation Matrix</h2>
            <InvestorGrievanceTable />
          </Container>
        </div>
      </>
    );
  }
}

export default Contact;
